import React from "react";
import { Container, Tabs, Tab, Spinner } from "react-bootstrap";
import useMentorAssessmentKits from "./useMentorAssessmentKits";
import "./MentorAssessmentKits.scss";
import { dateDiff } from "../../../_helpers/dateFormatter";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const navigate = useNavigate();

  const {
    loading,
    assessmentKits,
    countQuestions,
    onEditKitClick,
    onViewCandidatesClick,
  } = useMentorAssessmentKits();

  const publishedAssessmentKits = assessmentKits?.filter(
    (assessmentKit) => assessmentKit?.status === "publish"
  );
  const draftAssessmentKits = assessmentKits?.filter(
    (assessmentKit) => assessmentKit?.status === "draft"
  );

  return (
    <MainLayout activeMenuItem="Assessment Kit" pageName={"Assessment Kits"}>
      <Container className="footer-gap">
        <div className="applied-job-board">
          <div className="hiring-process-dashboard kanban-board-main mt-4">
            <Tabs defaultActiveKey="publishedAssessment">
              <Tab
                eventKey="publishedAssessment"
                title={`Published (${publishedAssessmentKits && publishedAssessmentKits.length
                  })`}
              >
                {Array.isArray(publishedAssessmentKits) &&
                  publishedAssessmentKits.length ? (
                  <div className="row">
                    {Array.isArray(publishedAssessmentKits) &&
                      publishedAssessmentKits.map((item, index) => (
                        <div className="col-lg-6 mb-4">
                          <div className="d-flex flex-column p-4 bg-white border position-relative h-100 rounded-lg ">
                            <div className="upper">
                              <div className="d-flex justify-content-between">
                                <div className="job-info">
                                  <h3 className="font-weight-medium mb-1 text-capitalize ">
                                    {item?.title}
                                  </h3>
                                </div>
                                <div className="d-flex">
                                  <button
                                    className="bg-transparent border-0 text-dark"
                                    onClick={() => {
                                      onEditKitClick(item?.id);
                                    }}
                                    title="Edit"
                                  >
                                    <img
                                      src="/assets/images/edit-grey.svg"
                                      alt="edit"
                                    />
                                  </button>
                                </div>
                              </div>
                              <div className="mb-3">
                                <div className="d-flex align-items-center fs-smallest  justify-content-between">
                                  <p className="text-grey-4 mb-0">
                                    Total Topics:{" "}
                                    <span className="font-weight-medium text-dark">
                                      {item?.topics && item?.topics.length}
                                    </span>{" "}
                                    | Total Questions:
                                    <span className="font-weight-medium  text-dark">
                                      {countQuestions(item && item?.topics)}
                                    </span>{" "}
                                    | Submitted:
                                    <span className="font-weight-medium  text-dark">
                                      {item?.submitted_interview_kits_count}
                                    </span>
                                  </p>
                                </div>

                                {Array.isArray(item?.topics) &&
                                  item.topics.length ? (
                                  <ul className="fs-14 d-flex align-items-center mb-0 flex-wrap">
                                    {item &&
                                      Array.isArray(item?.topics) &&
                                      item?.topics.map((topic) => (
                                        <li className="my-1 text-capitalize">
                                          Topic: {topic.name}
                                        </li>
                                      ))}
                                  </ul>
                                ) : null}
                              </div>
                              {Array.isArray(item?.all_skills) &&
                                item.all_skills.length > 0 ? (
                                <div className="d-flex align-items-center flex-wrap fs-smallest">
                                  <p className="mb-0 mr-2 text-capitalize mb-0">
                                    {Array.isArray(
                                      item?.all_skills && item?.all_skills
                                    ) &&
                                      item?.all_skills &&
                                      item?.all_skills.map((skill, index) => (
                                        <span
                                          key={index}
                                          className="skill bg-grey d-inline-block px-2 rounded-sm mr-2 my-1 py-1 mb-2"
                                        >
                                          {skill?.skill}
                                        </span>
                                      ))}
                                  </p>
                                </div>
                              ) : null}
                            </div>
                            <div className="d-flex justify-content-between align-items-center  flex-md-wrap flex-lg-nowrap mt-auto">
                              <p className="mb-0 mr-2  text-grey-4 fs-smallest">
                                Created {dateDiff(item?.created, new Date())}{" "}
                                ago
                              </p>
                              <div className="job-bottom d-flex align-items-center justify-content-between ">
                                <span
                                  className="text-primary py-2 mr-2 cursor-pointer text-nowrap font-weight-medium fs-smallest"
                                  onClick={() =>
                                    onViewCandidatesClick(item?.id)
                                  }
                                >
                                  View Candidates
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="text-center">
                    <img src={"./assets/images/warning.png"} alt="error" />
                    <h3 className="text-danger mb-4">
                      No Assessment kit published yet.
                    </h3>
                  </div>
                )}
              </Tab>
              <Tab
                eventKey="drafted"
                title={`Drafted (${draftAssessmentKits && draftAssessmentKits.length
                  })`}
              >
                <div className="mb-4 job-list-section">
                  {loading ? (
                    <>
                      <div className="d-flex align-items-center justify-content-center p-4">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    </>
                  ) : (
                    <>
                      {" "}
                      {Array.isArray(draftAssessmentKits) &&
                        draftAssessmentKits.length ? (
                        <>
                          <div className="row">
                            {Array.isArray(draftAssessmentKits) &&
                              draftAssessmentKits.map((item) => (
                                <div className="col-lg-6 mb-4">
                                  <div className="d-flex flex-column h-100 p-4 bg-white border position-relative rounded-lg">
                                    <div className="upper mb-3">
                                      <div className="d-flex justify-content-between">
                                        <div className="job-info">
                                          <h3 className="font-weight-medium mb-1 text-capitalize ">
                                            {item?.title}
                                          </h3>
                                        </div>
                                        <button
                                          className="bg-transparent border-0 py-2"
                                          onClick={(e) => {
                                            onEditKitClick(item?.id);
                                          }}
                                          title="Edit"
                                        >
                                          <img
                                            src="/assets/images/edit-grey.svg"
                                            alt="edit"
                                          />{" "}
                                        </button>
                                      </div>

                                      <div className="mb-3">
                                        <div className="d-flex align-items-center fs-smallest  justify-content-between">
                                          <p>
                                            Accepted:{" "}
                                            <span className="font-weight-medium">
                                              {
                                                item?.accepted_interview_kits_count
                                              }
                                            </span>{" "}
                                            | Submitted:
                                            <span className="font-weight-medium">
                                              {
                                                item?.submitted_interview_kits_count
                                              }
                                            </span>
                                          </p>
                                        </div>

                                        {Array.isArray(item?.topics) &&
                                          item.topics.length ? (
                                          <ul className="fs-14 d-flex align-items-center mb-0 flex-wrap">
                                            {item &&
                                              Array.isArray(item?.topics) &&
                                              item?.topics.map((topic) => (
                                                <li className="my-1 text-capitalize">
                                                  Topic: {topic.name}
                                                </li>
                                              ))}
                                          </ul>
                                        ) : null}

                                        {Array.isArray(item?.all_skills) &&
                                          item.all_skills.length > 0 ? (
                                          <div className="d-flex align-items-center flex-wrap fs-smallest">
                                            <p className="mb-0 mr-2 text-capitalize mb-0">
                                              {Array.isArray(
                                                item?.all_skills
                                              ) &&
                                                item?.all_skills.map(
                                                  (skill, index) => (
                                                    <span
                                                      key={index}
                                                      className="skill bg-grey d-inline-block px-2 rounded-sm mr-2 my-1 py-1 mb-2"
                                                    >
                                                      {skill?.skill}
                                                    </span>
                                                  )
                                                )}
                                            </p>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center  mt-auto">
                                      <p className="mb-0 mr-2 font-weight-medium text-muted fs-smallest">
                                        Created{" "}
                                        {dateDiff(item?.created, new Date())}{" "}
                                        ago
                                      </p>
                                      {draftAssessmentKits ? null :
                                        <div className="job-bottom d-flex align-items-center justify-content-between ">
                                          <span
                                            className="text-primary py-2 mr-2 cursor-pointer text-nowrap font-weight-medium fs-smallest"
                                            onClick={() =>
                                              onViewCandidatesClick(item?.id)
                                            }
                                          >
                                            View Candidates
                                          </span>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </>
                      ) : (
                        <div className="text-center">
                          <img
                            src={"./assets/images/warning.png"}
                            alt="error"
                          />
                          <h3 className="text-danger mb-4">
                            No Assessment Kit is in Draft
                          </h3>
                          <button
                            className="btn btn-primary"
                            onClick={() => navigate("/create-assessment")}
                          >
                            Create A New AssessmentKit
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </Container>
    </MainLayout>
  );
};
